module.exports = __webpack_public_path__ + "img/6.39a4b632.webp";